import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiError } from "@/lib/api/errors";
import { useSession } from "@/lib/auth/useSession";
import { Login } from "@/modules/auth/Login";
import { Router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Hisobotlar eventlardan quriladi va tez-tez o'zgaradi;
      // 30 soniya "yangi" deb hisoblanadi.
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Vakolat va validatsiya xatolarini qayta urinish
        // MA'NOSIZ: natija o'zgarmaydi, faqat server yuklanadi.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
  },
});

export function App() {
  const session = useSession();

  if (!session.isAuthenticated) {
    return (
      <QueryClientProvider client={queryClient}>
        <Login />
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  );
}
